import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef, inject, DestroyRef } from '@angular/core';
import { AccountFeatureEnum } from '@anecdotes/api-contracts';

import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AccountFeaturesService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[isAccountFeatureEnabled]',
  standalone: false,
})
export class AccountFeatureEnabledDirective implements OnInit, OnChanges {
  private readonly destroyRef = inject(DestroyRef);
  private accountFeatureSubject = new BehaviorSubject<AccountFeatureEnum>(null);

  @Input()
  isAccountFeatureEnabled: AccountFeatureEnum;

  @Input()
  isAccountFeatureEnabledElse: TemplateRef<any>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private accountFeaturesService: AccountFeaturesService
  ) {}

  ngOnInit(): void {
    this.accountFeatureSubject
      .pipe(
        switchMap((feature) => this.accountFeaturesService.doesAccountHaveFeature(feature)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((isAccountFeatureEnabled) => {
        this.viewContainerRef.clear();
        let embeddedView: EmbeddedViewRef<any>;

        if (isAccountFeatureEnabled) {
          embeddedView = this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else if (this.isAccountFeatureEnabledElse) {
          embeddedView = this.viewContainerRef.createEmbeddedView(this.isAccountFeatureEnabledElse);
        }

        embeddedView?.detectChanges();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('isAccountFeatureEnabled' in changes) {
      this.accountFeatureSubject.next(this.isAccountFeatureEnabled);
    }
  }
}
